import './fixed-product-bar.scss';
export default (() => {
  if (document.querySelector('.fixed-product-bar')) {
    window.addEventListener("scroll", function () {
      var header = document.querySelector("header");
      var productHeader = document.querySelector(".block-product-header");
      var footer = document.querySelector("footer");
      var fixedProductBar = document.querySelector(".fixed-product-bar");
      var headerHeight = header.offsetHeight; // Outer height of header
      var productHeaderHeight = productHeader.offsetHeight; // Outer height of product header

      var totalHeaderHeight = headerHeight + productHeaderHeight;
      var footerHeight = footer.offsetHeight; // Outer height of footer
      var totalFooterHeight = footerHeight;
      var heightFooter = document.body.scrollHeight - totalFooterHeight; // Height of the document minus footer height
      var scrollBottom = window.scrollY + window.innerHeight; // Current scroll position plus window height

      if (window.scrollY > totalHeaderHeight - 150 && scrollBottom < heightFooter + 150) {
        fixedProductBar.classList.add("show");
      } else {
        fixedProductBar.classList.remove("show");
      }
    });
    document.body.addEventListener("click", function (e) {
      if (e.target.matches(".fixed-product-bar .configure-button")) {
        e.preventDefault();
        // Scroll to the top of the page smoothly
        window.scrollTo({
          top: 0,
          behavior: "smooth"
        });
      }
    });
  }
});